export const ROLES: { GUEST: 'GUEST', BAYER: 'BAYER', CONTENT_MANAGER: 'CONTENT_MANAGER', WEBMASTER: 'WEBMASTER', ADMIN: 'ADMIN' } = {
  GUEST: 'GUEST',
  BAYER: 'BAYER',
  CONTENT_MANAGER: 'CONTENT_MANAGER',
  WEBMASTER: 'WEBMASTER',
  ADMIN: 'ADMIN'
}

